import CartHelper from '@/utils/cart-helper'

export default class OrderEstimateHolder {
  constructor(cartEstimate, getters) {
    this.immediateEstimate = cartEstimate.immediate_invoice_estimate || cartEstimate.order.immediate_invoice_estimate;
    this.creditnoteEstimates = cartEstimate.credit_note_estimates;
    this.contractTerm = cartEstimate.contract_term
    this.nextEstimates = cartEstimate.next_invoice_estimates || [];
    this.estimate = this.immediateEstimate || this.nextEstimates[0] || {};
    this.getters = getters;
    this.subscriptionEstimate = cartEstimate.subscription_estimate;
    this.originalEstimate = JSON.parse(JSON.stringify(cartEstimate));
    this.init();
  }

  init() {
    if(this.immediateEstimate && this.nextEstimates[0]) {
      if(!CartHelper.isDifferentEstimate(this.immediateEstimate, this.nextEstimates[0])) {
        this.nextEstimates.shift();
      }
    }
  }

  getDiscounts() {
    if(this.getters.is_cart_with_estimate) {
      return [].concat(this.estimate?.discounts || []).concat(this.getZeroDiscounts(this.getters?.order_items)) || [];
    } else {
        let discounts = (this.immediateEstimate && this.immediateEstimate.discounts) || [];
        this.nextEstimates.forEach(est => {
          est.discounts = est.discounts || [];
          est.discounts.forEach(discount => {
            let index = discounts.findIndex(d => d.entity_id == discount.entity_id);
            if(index == -1) {
              discounts = discounts.concat(discount);
            }
          });
        });
        discounts.concat(this.getZeroDiscounts(this.getters.order_items))
        return discounts;
    }
  }

  getZeroDiscounts(orderItems) {
    const coupons = orderItems?.coupon_list || []
    let zeroCoupons = []
    for(let coupon of coupons) {
      if(coupon?.details?.discount_amount == 0 && coupon?.details?.discount_type === "fixed_amount"){
        zeroCoupons.push({
          amount: 0,
          description: coupon?.details?.invoice_name || coupon?.details?.name,
          discount_type: "fixed_amount",
          entity_id: coupon?.details?.id,
          entity_type: "document_level_coupon",
          object: "discount"
        })
      }
    }
    return zeroCoupons
  }

}
